import { createReducer } from 'helpers/ReducerUtil'
import {
  CLEAR_APPROVER_LIST,
  UPDATE_APPROVER_LIST,
  UPDATE_APPROVER_PROFILE_IMAGE,
  UPDATE_APPROVER_APPROVALS_LIST,
} from './constants'

const updateApproverList = (approvers, action) => action.approvers ? action.approvers : []
const updateApproverApprovalsList = (approvals, action) => action.approvals ? action.approvals : []
const updateApproverImages = (images, action) => (
  action.image
    ? [... new Set([...images, action.image])]
    : images
)

const workflowApproverReducer = createReducer([], {
  [CLEAR_APPROVER_LIST]: () => [],
  [UPDATE_APPROVER_LIST]: updateApproverList,
})

const workflowApproverApprovalReducer = createReducer([], {
  [CLEAR_APPROVER_LIST]: () => [],
  [UPDATE_APPROVER_APPROVALS_LIST]: updateApproverApprovalsList,
})

const approverImageReducer = createReducer([], {
  [CLEAR_APPROVER_LIST]: () => [],
  [UPDATE_APPROVER_PROFILE_IMAGE]: updateApproverImages,
})

export {
  approverImageReducer,
  workflowApproverReducer,
  workflowApproverApprovalReducer,
}
